module.exports = __webpack_public_path__ + "e42d608caeb0e6b6f56e46c2b2edb8a4.svg";